import { render, staticRenderFns } from "./DesignFormAddressModal.vue?vue&type=template&id=0d3d5624&scoped=true&"
import script from "./DesignFormAddressModal.vue?vue&type=script&lang=js&"
export * from "./DesignFormAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d5624",
  null
  
)

export default component.exports